module.exports = __webpack_public_path__ + "static/media/javascript-logo.32e44a7b.png";